import baseInitState from 'src/helpers/redux/baseInitState'
import baseReducer from 'src/helpers/redux/baseReducer'

import { actionType } from './kategoriUmroh.action'

export default function reducer(state = baseInitState, action) {
  return baseReducer(state, action, actionType)
}
